<template>
  <div>
    <!-- 搜索/新增 -->
    <div class="list-hd">
      <el-form :inline="true" v-model="searchValue" class="demo-form-inline">
        <el-form-item label="日期:">
          <el-date-picker
            v-model="value1"
            type="daterange"
            range-separator="至"
            value-format="yyyy-MM-dd HH:mm:ss"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :default-time="['00:00:00', '23:59:59']"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="所属游戏:">
          <el-select
            v-model="searchValue.game_id"
            filterable
            clearable
            placeholder="请选择"
            @change="selectChannel"
          >
            <el-option
              v-for="item in gamesList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="所属渠道:" v-if="isShow">
          <el-select
            v-model="searchValue.channel_id"
            filterable
            clearable
            multiple
            placeholder="请选择"
          >
            <el-option
              v-for="item in channelSelectList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="渠道包组:">
          <el-select
            v-model="searchValue.group_channel_ids"
            filterable
            clearable
            placeholder="请选择"
          >
            <el-option
              v-for="item in channelGroupSelectList"
              :key="item.id"
              :label="item.group_name"
              :value="item.group_channel_ids"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="游戏母包:">
          <el-select
            v-model="searchValue.game_package_id"
            filterable
            clearable
            placeholder="请选择"
          >
            <el-option
              v-for="item in gamePackageSelectList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>

        <commonMode
          ref="commonMode"
          @getList="(val) => {
            searchValue = {
              ...searchValue,
              ...val,
            }
            getReportList(true)
          }"
          :searchValue="{
            channel_id: searchValue.channel_id
          }" />
        <el-form-item>
          <el-button size="small" type="warning" @click="$refs.commonMode.dialogTableVisible = true">选择渠道策略组</el-button>
        </el-form-item>
        <el-form-item>
          <el-button size="small" type="success" @click="$refs.commonMode.dialogCreateModeVisible = true">保存渠道策略组</el-button>
        </el-form-item>
        <br />
        <el-form-item>
          <el-checkbox
            v-model="searchValue.is_channel"
            @change="(flag) => {
              if (flag) {
                searchValue.is_game = true
                searchValue.is_package = false
                searchValue.is_group = false
              }
            }">渠道</el-checkbox>
        </el-form-item>
        <el-form-item>
          <el-checkbox
            v-model="searchValue.is_package"
            @change="(flag) => {
              searchValue.is_game = !flag
              if (flag) {
                searchValue.is_channel = false
                searchValue.is_group = false
              }
            }">渠道包</el-checkbox>
        </el-form-item>
        <el-form-item>
          <el-checkbox
            v-model="searchValue.is_group"
            @change="(flag) => {
              searchValue.is_game = !flag
              if (flag) {
                searchValue.is_channel = false
                searchValue.is_package = false
              }
            }">渠道组</el-checkbox>
        </el-form-item>
        <el-form-item label="统计类型:">
          <el-select
            v-model="searchValue.append_type"
            filterable
            clearable
            placeholder="请选择"
          >
            <el-option
              v-for="item in appendTypeList"
              :key="item.value"
              :label="item.name"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="searchReportList">搜索</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="success" @click="exportReport()">导出</el-button>
        </el-form-item>
      </el-form>
    </div>
    <el-table
      stripe
      ref="table"
      v-loading="loadingData"
      :data="tableData"
      :summary-method="getSummaries"
      show-summary
      :max-height="tableHeight"
      border
      style="width: 100%"
      @sort-change="sortChange"
    >
      <el-table-column fixed prop="daydate" label="统计日期" width="100" :resizable="false"> </el-table-column>
      <el-table-column v-if="!showGroup" prop="game.name" label="所属游戏" width="180" :resizable="false"> </el-table-column>
      <el-table-column v-if="showChannel" prop="channels.name" label="所属渠道" width="180" :resizable="false"> </el-table-column>
      <el-table-column v-if="showPackage" prop="packages.name" label="渠道包名" width="180" :resizable="false"> </el-table-column>
      <el-table-column v-if="showGroup" prop="group_name" label="渠道组" width="180" :resizable="false"> </el-table-column>

      <el-table-column label="当日数据" header-align="center">
        <el-table-column prop="login_num" sortable=“custom” label="登录人数" :resizable="false"> </el-table-column>
        <el-table-column prop="money" sortable=“custom” label="充值金额" :resizable="false"> </el-table-column>
        <el-table-column prop="moneyPay" sortable=“custom” label="平台币支付" :resizable="false"> </el-table-column>
        <el-table-column prop="ios_total_pay" sortable=“custom” label="iOS总支付" width="90" :resizable="false">
        </el-table-column>
        <el-table-column prop="apple_pay" sortable=“custom” label="applepay支付" width="110" :resizable="false">
        </el-table-column>
        <el-table-column prop="cut_pay" sortable=“custom” label="切支付" :resizable="false">
        </el-table-column>
        <el-table-column prop="pay_num" sortable=“custom” label="付费人数" :resizable="false"> </el-table-column>
        <el-table-column prop="pay_rate" label="付费率" :resizable="false">
          <template slot-scope="scope">{{ scope.row.pay_rate }}%</template>
        </el-table-column>
        <el-table-column prop="channel_first_num" sortable=“custom” label="渠道初次登录" :resizable="false"> </el-table-column>
      </el-table-column>
      
      <el-table-column label="新增数据" header-align="center">
        <el-table-column prop="reg_num" sortable=“custom” label="新增注册" :resizable="false"> </el-table-column>
        <el-table-column prop="reg_no_repeat" sortable=“custom” label="手机注册数" :resizable="false">
        </el-table-column>
        <el-table-column prop="device_pay" sortable=“custom” label="新增付费设备数" :resizable="false">
        </el-table-column>
        <el-table-column prop="device_reg" sortable=“custom” label="新增注册设备数" :resizable="false">
        </el-table-column>
        <el-table-column prop="device_activate" sortable=“custom” label="新增激活设备数" :resizable="false">
        </el-table-column>
      </el-table-column>

      <el-table-column label="首日和累计" header-align="center">
        <el-table-column prop="total_pay_num" sortable=“custom” label="累计新增付费人数" :resizable="false">
        </el-table-column>
        <el-table-column prop="cut_time_money" sortable=“custom” label="此时充值" :resizable="false">
        </el-table-column>
        <el-table-column prop="total_new_money" sortable=“custom” label="累计新增付费金额" :resizable="false">
        </el-table-column>
        <el-table-column prop="new_first_money" sortable=“custom” label="首日付费金额" :resizable="false">
        </el-table-column>
        <el-table-column prop="first_money_num" sortable=“custom” label="首日付费人数" :resizable="false">
        </el-table-column>
        <el-table-column prop="first_pay_rate" label="首日付费率" :resizable="false">
          <template slot-scope="scope">{{ scope.row.first_pay_rate }}%</template>
        </el-table-column>
      </el-table-column>
      
      <el-table-column label="平均收益" header-align="center">
        <el-table-column prop="arppu" label="付费AP" :resizable="false"> </el-table-column>
        <el-table-column prop="arpu" label="活跃AP" :resizable="false"> </el-table-column>
        <el-table-column prop="new_first_arppu" label="首日付费AP" :resizable="false">
        </el-table-column>
        <el-table-column prop="new_first_arpu" label="首日活跃AP" :resizable="false">
        </el-table-column>
      </el-table-column>

    </el-table>
    <!-- 分页 -->
    <div class="pagination">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalRecords"
      >
      </el-pagination>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import fetch from "@/assets/js/axios.js";
import { urlSplicing } from "@/assets/js/public.js";
import moment from "moment";
import commonMode from '@/component/commonMode.vue';

export default {
  name: "channelReport",
  components: {
    commonMode
  },
  data() {
    return {
      // 排序
      sortObj: {},
      loadingData: false,
      value1: [],
      collect: [],
      searchValue: {
        game_id: "",
        channel_id: [],
        created_from: "",
        created_to: "",
        group_channel_ids: "",
        append_type: "reg_num",
        is_channel: false,
        is_game: true,
        is_package: false,
        is_group: false,
        game_package_id: "",
      },
      showChannel: true,
      showPackage: false,
      showGroup: false,
      listRechannel: [
        {
          id: 0,
          name: "分渠道",
        },
        {
          id: 1,
          name: "不分渠道",
        },
      ],
      isShow: true,
      tableHeight: 0,
      historyValue: {},
      tableData: [],
      totalRecords: 0,
      currentPage: 1,
      pageSize: 10,
      gamesList: [],
      channelSelectList: [],
      channelSelectAllList: [],
      channelGroupSelectList: [],
      gamePackageSelectList: [],
      appendTypeList: [
        {
          value: 'reg_num',
          name: '新增用户'
        },
        {
          value: 'total_num',
          name: '总新增角色'
        },
        {
          value: 'first_num',
          name: '初次新增角色'
        },
        {
          value: 'repeat_num',
          name: '滚服角色数据'
        },
        {
          value: 'unique_devices',
          name: '设备去重'
        },
        {
          value: 'unique_ip',
          name: '用户IP去重'
        },
        {
          value: 'unique_double',
          name: '用户IP设备双去重'
        },
      ],
    };
  },
  computed: {
    ...mapState(["host"]),
  },
  created() {
    this.value1[0] = moment(new Date()).format("YYYY-MM-DD 00:00:00")
    this.value1[1] = moment(new Date()).format("YYYY-MM-DD 23:59:59")

    this.searchValue.created_from = this.value1[0];
    this.searchValue.created_to = this.value1[1];

    // 是否分渠道 默认选中项
    // this.searchValue.rechannel = this.listRechannel[0].id;

    this.getGameSelectList();
    this.getChannelSelect();
    this.channelGroupSelect();
    this.gamePackageSelect()
    this.getReportList(true);
  },
  updated() {
    this.$nextTick(() => {
      this.$refs["table"].doLayout();
    });
  },
  beforeMount(height) {
    var h = document.documentElement.clientHeight;
    this.tableHeight = h - 60; //减去页面上固定高度height
  },
  methods: {
    // 排序
    sortChange({ prop, order }) {
      const obj = {
        field: prop,
        sort: order && order.replace("ending", ""),
      }
      this.sortObj = obj
      this.getReportList(false)
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.getReportList(false);
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getReportList(false);
    },

    addDate() {
      let date1 = moment().endOf("month"); //当月最后一天
      let yy = date1.get("year");
      let mm = date1.get("month") + 1;
      let dd = date1.get("date");
      this.systemTime = yy + "-" + mm + "-" + dd + " " + "23:59:59";
    },

    // 导出
    exportReport() {
      let params = {
        ...this.historyValue, // 传对应的搜索的值
        export: 1,
        token: sessionStorage.getItem("access_token"),
        is_channel: Number(this.historyValue.is_channel),
        is_game: Number(this.historyValue.is_game),
        is_package: Number(this.historyValue.is_package),
        is_group: Number(this.historyValue.is_group),
      }

      urlSplicing(this.host + "admin/package_statistics/total_data_report", params);
    },

    // 获取游戏选择列表数据
    getGameSelectList() {
      fetch({
        url: "/admin/games/select",
        method: "GET",
      }).then((res) => {
        this.gamesList = res.data.data;
      });
    },
    // 获取渠道选择列表数据
    getChannelSelect() {
      fetch({
        url: "/admin/channels/select",
        method: "GET",
      }).then((res) => {
        this.channelSelectAllList = res.data.data;
        this.channelSelectList = res.data.data;
      });
    },
    // 渠道包组 下拉选择列表
    channelGroupSelect() {
      fetch({
        url: "/admin/channel_package_group/select",
        method: "GET",
      }).then((res) => {
        this.channelGroupSelectList = res.data.data;
      });
    },
    // 渠道包组 下拉选择列表
    gamePackageSelect() {
      fetch({
        url: "/admin/game_packages/select",
        method: "GET",
      }).then((res) => {
        this.gamePackageSelectList = res.data.data;
      });
    },

    // 通过选择是否分渠道 控制所属渠道是否显示或隐藏
    // rechannelChange(selectValue) {
    //   if (selectValue == 1) {
    //     this.isShow = false;
    //   } else {
    //     this.isShow = true;
    //   }
    // },
    // 根据所属游戏,显示对应的所属渠道
    selectChannel(vid) {
      let obj = {};
      obj = this.gamesList.find((item) => {
        return item.id == vid;
      });
      this.channelSelectList = [];
      this.channelSelectAllList.forEach((item, i) => {
        if (obj) {
          if (item.game_id == obj.id) {
            this.channelSelectList.push(item);
          }
        } else {
          this.channelSelectList.push(item);
        }
      });
    },
    // 实现渠道包数据的搜索
    searchReportList() {
      this.searchValue.created_from = this.value1 && this.value1.length === 2 ? this.value1[0] : '';
      this.searchValue.created_to = this.value1 && this.value1.length === 2 ? this.value1[1] : '';
      this.currentPage = 1;
      this.getReportList(true);
    },
    // 展示用户角色列表数据
    getReportList(reload = false) {
      let searchValue = {};
      if (reload) {
        this.historyValue = JSON.parse(JSON.stringify(this.searchValue));
        searchValue = this.searchValue;
      } else {
        searchValue = this.historyValue;
      }
      this.loadingData = true;
      let channel_id = searchValue.channel_id.toString();
      fetch({
        url: "/admin/package_statistics/total_data_report",
        method: "GET",
        params: {
          ...searchValue,
          channel_id: channel_id,
          page: this.currentPage,
          per_page: this.pageSize,
          is_channel: Number(searchValue.is_channel),
          is_game: Number(searchValue.is_game),
          is_package: Number(searchValue.is_package),
          is_group: Number(searchValue.is_group),
          ...this.sortObj,
        },
      })
        .then((res) => {
          if (res.data.status) {
            this.tableData = res.data.data[0].data;
            this.collect = res.data.data.collect;
            this.totalRecords = res.data.data[0].total;
            this.showChannel = searchValue.is_channel
            this.showPackage = searchValue.is_package
            this.showGroup = searchValue.is_group
          }
        })
        .finally(() => {
          this.loadingData = false;
        });
    },
    // 数据统计
    getSummaries({ columns }) {
      let arr = [];
      const keyList = {
        'login_num': 'login_num',
        'money': 'money_total',
        'pay_num': 'disc_pay_num',
        'pay_rate': 'pay_rate',
        'arppu': 'arppu',
        'arpu': 'arpu',
        'reg_num': 'reg_num_total',
        'reg_no_repeat': 'user_total',
        'device_pay': 'device_pay',
        'device_reg': 'device_reg',
        'device_activate': 'device_activate',
        'new_first_money': 'new_first_money_total',
        'first_money_num': 'disc_first_money_num',
        'first_pay_rate': 'first_pay_rate',
        'new_first_arppu': 'new_first_arppu',
        'new_first_arpu': 'new_first_arpu',
        'total_pay_num': 'total_pay_num',
        'total_new_money': 'total_new_money',
        'channel_first_num': 'channel_first_num',
        'cut_time_money': 'cut_time_money',
        'apple_pay': 'apple_pay',
        'cut_pay': 'cut_pay',
        'ios_total_pay': 'ios_total_pay',
        'moneyPay': 'moneyPay',
      }
      columns.forEach(item => {
        let result = ''
        const property = item?.property
        const target = property && keyList[property]
        if (target) {
          result = this.collect[target]
          if (property.indexOf('rate') !== -1) result += '%'
        }
        arr.push(result)
      })
      arr.splice(0, 1, "合计")
      return arr;
    },
  },
};
</script>
<style lang="less">
.pagination {
  text-align: right;
  margin-top: 20px;
  padding-bottom: 20px;
}
.list-hd {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 20px;
  .el-input-group {
    width: 370px;
  }
}
</style>
